import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plantillas',
  templateUrl: './plantillas.component.html',
  styleUrls: []
})
export class PlantillasComponent implements OnInit {

  rol: number = 0;     
  constructor() {
    let u = JSON.parse(localStorage.getItem('u'));
    if (u != null) {
      this.rol = u.rol;
    }
  }

  ngOnInit() {
  }

}
